export default class FlashMessageUtil {
  static flashMessageContainer = document.querySelector(
    '#configuration-flash-message'
  );
  static successHeader =
    FlashMessageUtil.flashMessageContainer?.querySelector('.success-header');
  static messageText =
    FlashMessageUtil.flashMessageContainer?.querySelector('.message-text');
  static undoButton =
    FlashMessageUtil.flashMessageContainer?.querySelector('.undo-button');
  static flashMessageTimeout;

  static removeAllClickListeners(elem) {
    const clickListeners = elem.onclick ? [elem.onclick] : [];
    const clickListenersClone = [...clickListeners];

    clickListenersClone.forEach((listener) => {
      elem.removeEventListener('click', listener);
    });
  }

  static hideFlashMessage() {
    FlashMessageUtil.flashMessageContainer.style.display = 'none';
    FlashMessageUtil.messageText.innerHTML = '';
    FlashMessageUtil.flashMessageContainer.classList.remove('error');
    FlashMessageUtil.successHeader.style.display = 'none';
    FlashMessageUtil.undoButton.style.display = 'none';
  }

  static showFlashMessage({
    message,
    undoHandler = null,
    onDestroy = null,
    error = false
  }) {
    FlashMessageUtil.removeAllClickListeners(FlashMessageUtil.undoButton);
    FlashMessageUtil.messageText.innerHTML = message;
    FlashMessageUtil.flashMessageContainer.style.display = 'block';

    if (error) {
      FlashMessageUtil.successHeader.style.display = 'none';
      FlashMessageUtil.flashMessageContainer.classList.add('error');
    } else {
      FlashMessageUtil.successHeader.style.display = 'block';
    }

    if (undoHandler) {
      FlashMessageUtil.undoButton.style.display = 'block';
      FlashMessageUtil.undoButton.addEventListener('click', undoHandler);
    } else {
      FlashMessageUtil.undoButton.style.display = 'none';
    }

    window.scrollTo({ top: 0 });

    clearTimeout(FlashMessageUtil.flashMessageTimeout);

    FlashMessageUtil.flashMessageTimeout = setTimeout(() => {
      FlashMessageUtil.hideFlashMessage();
      if (onDestroy) {
        onDestroy();
      }
    }, 10000);
  }
}
